// extracted by mini-css-extract-plugin
export var filterIncDec = "_5g-0";
export var leftBorder = "_5g-1";
export var rightBorder = "_5g-2";
export var stringInput = "_5g-3";